<template>
  <v-card v-if="topic">
    <v-card-title>
      {{ topic.name }}
    </v-card-title>
    <v-card-subtitle class="caption">
      <v-row>
        <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ topic.id }} </v-col>
        <v-col
          v-if="topic.industry"
          cols="auto"
        >
          <span class="font-weight-bold">Industry</span>
          {{ topic.industry.name }}
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="topic.name"
              label="Name"
              outlined
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12">
            <v-menu
              v-model="start_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="topic.marketingStartDate"
                  label="Marketing Start"
                  readonly
                  v-bind="attrs"
                  outlined
                  hide-details="auto"
                  clearable
                  :rules="[startRequired]"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="topic.marketingStartDate"
                :max="topic.marketingEndDate"
                @input="start_menu = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-menu
              v-model="end_menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="topic.marketingEndDate"
                  label="Marketing End"
                  readonly
                  v-bind="attrs"
                  outlined
                  hide-details="auto"
                  :rules="[endRequired, endGreater]"
                  clearable
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="topic.marketingEndDate"
                :min="topic.marketingStartDate"
                @input="end_menu = false"
              />
            </v-menu>
          </v-col>
          <v-col
            v-if="topic.popularity"
            cols="12"
          >
            <v-select
              v-model="topic.popularity.id"
              label="Popularity"
              :items="popularity"
              :rules="[$rules.required]"
              outlined
              hide-details="auto"
              item-value="id"
              item-text="name"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="topic.active"
              label="Active?"
              hint="Retiring a topic removes it from campaign targets, blog anchors, generation candidates and the profession picker. Existing links, pages and customer profiles keep working. Blocked while the topic still has published templates."
              persistent-hint
              color="primary"
              inset
              outlined
              class="pt-0 mt-0"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="topic.disableInCatalog"
              label="Disable in catalog"
              hint="Hides a LIVE topic from catalog browse and search only — it stays fully active everywhere else."
              persistent-hint
              color="primary"
              inset
              outlined
              class="pt-0 mt-0"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-btn
        color="primary"
        :loading="saving"
        block
        @click="save"
      >
        Save
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EditTopic',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      start_menu: false,
      end_menu: false
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    topic: {
      get() {
        return this.$store.getters['topics/edit_topic'];
      },
      set(val) {
        this.$store.dispatch('topics/edit', val);
      }
    },
    ...mapGetters({ popularity: 'lookup/popularity' })
  },

  async mounted() {},

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('topics/update', this.topic)
        .then(() => {
          this.$root.$snackbarSuccess('Topic saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    startRequired(val) {
      return !(this.topic.marketingEndDate && !val) || 'Required';
    },
    endRequired(val) {
      return !(this.topic.marketingStartDate && !val) || 'Required';
    },
    endGreater(val) {
      return (
        !(this.topic.marketingStartDate && val && this.topic.marketingStartDate > val) ||
        'End date must be after Start Date'
      );
    }
  }
};
</script>
